import { PeopleBody } from 'people/main';
import React from 'react';

export const PeoplePage = () => <PeopleBody />;
